var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.55 0.924998L14.175 3.525C13.4083 3.45833 12.8 3.59167 12.35 3.925C11.9 4.24167 11.5917 4.7 11.425 5.3C11.275 5.88333 11.25 6.55 11.35 7.3H14.55V13.725H8.375V7.05C8.375 4.86666 8.89167 3.21666 9.925 2.1C10.9583 0.966665 12.5 0.574998 14.55 0.924998ZM6.175 0.924998L5.8 3.525C5.03333 3.45833 4.425 3.59167 3.975 3.925C3.525 4.24167 3.21667 4.7 3.05 5.3C2.9 5.88333 2.875 6.55 2.975 7.3H6.175V13.725H2.83122e-07V7.05C2.83122e-07 4.86666 0.516667 3.21666 1.55 2.1C2.58333 0.966665 4.125 0.574998 6.175 0.924998Z",
    fill: "#EF6D58"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.2e041903d5ecdcb83c0d11daea50362f.svg";
export { ForwardRef as ReactComponent };